import { render, staticRenderFns } from "./BaseUserMenu.vue?vue&type=template&id=67093e5e"
import script from "./BaseUserMenu.vue?vue&type=script&lang=js"
export * from "./BaseUserMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports